import React from "react";

interface Props {
  value?: string | number | null;
  onChange?: (value: string) => void;
}

export const AccountingAccountFilter: React.FC<Props> = ({ value, onChange }) => {
  return (
    <select
      className="border px-2 py-1 rounded text-sm text-gray-700"
      value={value ?? ""}
      onChange={(e) => onChange?.(e.target.value)}
    >
      <option value="">Tất cả loại tài khoản</option>
      <option value="1">Tài khoản tổng</option>
      <option value="2">Tài khoản chi tiết</option>
    </select>
  );
};

